function getFocusableElements(container) {
    return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"))
}
class SectionId {
    static #separator = '__';
    static parseId(qualifiedSectionId) {
        return qualifiedSectionId.split(SectionId.#separator)[0]
    }
    static parseSectionName(qualifiedSectionId) {
        return qualifiedSectionId.split(SectionId.#separator)[1]
    }
    static getIdForSection(sectionId, sectionName) {
        return `${sectionId}${SectionId.#separator}${sectionName}`
    }
}
class HTMLUpdateUtility {
    static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
        preProcessCallbacks?.forEach((callback) => callback(newContent));
        const newNodeWrapper = document.createElement('div');
        HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
        const newNode = newNodeWrapper.firstChild;
        const uniqueKey = Date.now();
        oldNode.querySelectorAll('[id], [form]').forEach((element) => {
            element.id && (element.id = `${element.id}-${uniqueKey}`);
            element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`)
        });
        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';
        postProcessCallbacks?.forEach((callback) => callback(newNode));
        setTimeout(() => oldNode.remove(), 500)
    }
    static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
            const newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value)
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag)
        })
    }
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id)
    }
    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
    });
    if (summary.closest('header-drawer, menu-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape)
});
const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
    removeTrapFocus();
    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', trapFocusHandlers.keydown)
    };
    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown)
    };
    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus()
        }
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus()
        }
    };
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
    elementToFocus.focus();
    if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length)
    }
}
try {
    document.querySelector(':focus-visible')
} catch (e) {
    focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN', ];
    let currentFocusedElement = null;
    let mouseClick = null;
    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = !1
        }
    });
    window.addEventListener('mousedown', (event) => {
        mouseClick = !0
    });
    window.addEventListener('focus', () => {
        if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
        if (mouseClick) return;
        currentFocusedElement = document.activeElement;
        currentFocusedElement.classList.add('focused')
    }, !0)
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*')
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    })
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', !1);
    summaryElement.focus()
}
class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', {
            bubbles: !0
        });
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)))
    }
    quantityUpdateUnsubscriber = undefined;
    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this))
    }
    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber()
        }
    }
    onInputChange(event) {
        this.validateQtyRules()
    }
    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        if (event.target.name === 'plus') {
            if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
                this.input.value = this.input.dataset.min
            } else {
                this.input.stepUp()
            }
        } else {
            this.input.stepDown()
        }
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
        if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
            this.input.value = parseInt(this.input.min)
        }
    }
    validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min))
        }
        if (this.input.max) {
            const max = parseInt(this.input.max);
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");
            buttonPlus.classList.toggle('disabled', value >= max)
        }
    }
}
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait)
    }
}

function throttle(fn, delay) {
    let lastCall = 0;
    return function(...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return
        }
        lastCall = now;
        return fn(...args)
    }
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: `application/${type}`
        },
    }
}
if (typeof window.Shopify == 'undefined') {
    window.Shopify = {}
}
Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments)
    }
};
Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i
        }
    }
};
Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, !1) : target.attachEvent('on' + eventName, callback)
};
Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options.method || 'post';
    var params = options.parameters || {};
    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);
    for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField)
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form)
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options.hideElement || province_domid);
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
    this.initCountry();
    this.initProvince()
};
Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler()
    },
    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value)
        }
    },
    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);
        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none'
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt)
            }
            this.provinceContainer.style.display = ''
        }
    },
    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild)
        }
    },
    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt)
        }
    },
};
class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents()
    }
    bindEvents() {
        this.querySelectorAll('summary').forEach((summary) => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)').forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)))
    }
    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;
        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement)
    }
    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus)
        }
        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
            if (window.matchMedia('(max-width: 990px)')) {
                document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
            }
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', !0);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
                !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus)
            }, 100)
        }
    }
    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening')
        });
        summaryElement.setAttribute('aria-expanded', !0);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(event, elementToFocus = !1) {
        if (event === undefined) return;
        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
            details.removeAttribute('open');
            details.classList.remove('menu-opening')
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
            submenu.classList.remove('submenu-open')
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
        if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', !1);
    }
    onFocusOut() {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
                this.closeMenuDrawer();
        })
    }
    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement)
    }
    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', !1);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement)
    }
    closeAnimation(detailsElement) {
        let animationStart;
        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time
            }
            const elapsedTime = time - animationStart;
            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation)
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'))
                }
            }
        };
        window.requestAnimationFrame(handleAnimation)
    }
}
customElements.define('menu-drawer', MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super()
    }
    openMenuDrawer(summaryElement) {
        this.header = this.header || document.querySelector('.section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        this.header.classList.add('menu-open');
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening')
        });
        summaryElement.setAttribute('aria-expanded', !0);
        window.addEventListener('resize', this.onResize);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
    }
    closeMenuDrawer(event, elementToFocus) {
        if (!elementToFocus) return;
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
        window.removeEventListener('resize', this.onResize)
    }
    onResize = () => {
        this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
    }
}
customElements.define('header-drawer', HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, !1));
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            })
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            })
        }
    }
    connectedCallback() {
        if (this.moved) return;
        this.moved = !0;
        this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
        if (!this.classList.contains("product-media-modal")) {
            document.body.appendChild(this)
        }
    }
    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia()
    }
    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia()
    }
}
customElements.define('modal-dialog', ModalDialog);
class BulkModal extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            if (this.innerHTML.trim() === '') {
                const productUrl = this.dataset.url.split('?')[0];
                fetch(`${productUrl}?section_id=bulk-quick-order-list`).then((response) => response.text()).then((responseText) => {
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
                    this.innerHTML = sourceQty.innerHTML
                }).catch((e) => {
                    console.error(e)
                })
            }
        };
        new IntersectionObserver(handleIntersection.bind(this)).observe(document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`))
    }
}
customElements.define('bulk-modal', BulkModal);
// class ModalOpener extends HTMLElement {
//     constructor() {
//         super();
//         const button = this.querySelector('button');
//          const button2 = this.querySelector('#myimage');
//         if (!button) return;
//         button.addEventListener('click', () => {
//             const modal = document.querySelector(this.getAttribute('data-modal'));
//             if (modal) modal.show(button);
//         });
//          button2.addEventListener('click', () => {
//             const modal = document.querySelector(this.getAttribute('data-modal'));
//             if (modal) modal.show(button);
//         })
//     }
// }
// customElements.define('modal-opener', ModalOpener);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    const mediaContainer = this.querySelector('.product__media');
    
    if (!button) return;
    
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) {
        // Set the current media ID before showing the modal
        const mediaId = button.getAttribute('data-media-id');
        this.setCurrentMediaId(mediaId);
        modal.show(button);
      }
    });
    
    // Also allow clicking on the image itself to open modal
    if (mediaContainer) {
      mediaContainer.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) {
          const mediaId = mediaContainer.getAttribute('data-media-id');
          this.setCurrentMediaId(mediaId);
          modal.show(button);
        }
      });
    }
  }
  
  setCurrentMediaId(mediaId) {
    // Store the current media ID in a data attribute on the modal opener
    this.setAttribute('data-current-media', mediaId);
    
    // Also set it on the modal itself for easy access
    const modal = document.querySelector(this.getAttribute('data-modal'));
    if (modal) {
      modal.setAttribute('data-current-media', mediaId);
    }
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this))
    }
    loadContent(focus = !0) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(!0));
            this.setAttribute('loaded', !0);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
                deferredElement.play()
            }
        }
    }
}
customElements.define('deferred-media', DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = !1;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.slideshowControlWrapper = this.querySelector('.slideshow__control-wrapper');
        this.slideshowControlVisual = this.slider.getAttribute('data-slider-visual');
        this.slideshowSectionId = this.slider.getAttribute('data-section-id');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        if (!this.slider || !this.nextButton) return;
        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);
        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        if (!this.sliderControlWrapper) return;
        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)))
    }
    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.round((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update()
    }
    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages()
    }
    update() {
        if (!this.slider || !this.nextButton) return;
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages
        }
        if (this.slideshowControlWrapper && (this.slideshowControlVisual === 'dots' || this.slideshowControlVisual === 'numbers')) {
            this.slideshowControlWrapper.innerHTML = '';
            for (let i = 0; i < this.totalPages; i++) {
                const button = document.createElement('button');
                button.className = `slider-counter__link slider-counter__link--${this.slideshowControlVisual} link`;
                button.setAttribute('aria-label', `Slide ${i + 1} of ${this.totalPages}`);
                button.setAttribute('aria-controls', `Slider-${this.slideshowSectionId}`);
                if (this.slider.getAttribute('data-slider-visual') === 'dots') {
                    const span = document.createElement('span');
                    span.className = 'dot';
                    button.appendChild(span)
                } else {
                    button.textContent = i + 1
                }
                this.slideshowControlWrapper.appendChild(button);
                this.sliderControlLinksArray = Array.from(this.slideshowControlWrapper.querySelectorAll('.slider-counter__link'));
                this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)))
            }
        }
        if (this.currentPage != previousPage) {
            this.dispatchEvent(new CustomEvent('slideChanged', {
                detail: {
                    currentPage: this.currentPage,
                    currentElement: this.sliderItemsToShow[this.currentPage - 1],
                },
            }))
        }
        if (this.enableSliderLooping) return;
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute('disabled', 'disabled')
        } else {
            this.prevButton.removeAttribute('disabled')
        }
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute('disabled', 'disabled')
        } else {
            this.nextButton.removeAttribute('disabled')
        }
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');
        if (!this.sliderControlButtons.length) return;
        this.sliderControlButtons.forEach(link => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current')
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', !0)
    }
    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft
    }
    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + step * this.sliderItemOffset : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.setSlidePosition(this.slideScrollPosition)
    }
    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition = this.slider.scrollLeft + this.slider.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition
        })
    }
    setSlidePosition(position) {
        this.slider.scrollTo({
            left: position,
        })
    }
}
customElements.define('slider-component', SliderComponent);
class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = !0;
        if (!this.sliderControlWrapper) return;
        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide, .multicolumn-list__item');
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
        this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
        this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;
        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();
        if (this.announcementBarSlider) {
            this.announcementBarArrowButtonWasClicked = !1;
            this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
            this.reducedMotion.addEventListener('change', () => {
                if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
            });
            [this.prevButton, this.nextButton].forEach((button) => {
                button.addEventListener('click', () => {
                    this.announcementBarArrowButtonWasClicked = !0
                }, {
                    once: !0
                })
            })
        }
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
    setAutoPlay() {
        this.autoplaySpeed = this.slider.dataset.speed * 1000;
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));
        if (this.querySelector('.slideshow__autoplay')) {
            this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
            this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
            this.autoplayButtonIsSetToPlay = !0;
            this.play()
        } else {
            this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play()
        }
    }
    onButtonClick(event) {
        super.onButtonClick(event);
        this.wasClicked = !0;
        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.totalPages;
        if (!isFirstSlide && !isLastSlide) {
            this.applyAnimationToAnnouncementBar(event.currentTarget.name);
            return
        }
        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0
        }
        this.setSlidePosition(this.slideScrollPosition);
        this.applyAnimationToAnnouncementBar(event.currentTarget.name)
    }
    setSlidePosition(position) {
        if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
        this.setPositionTimeout = setTimeout(() => {
            this.slider.scrollTo({
                left: position,
            })
        }, this.announcerBarAnimationDelay)
    }
    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');
        if (!this.sliderControlButtons.length) return;
        this.sliderControlButtons.forEach((link) => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current')
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', !0)
    }
    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay
    }
    focusOutHandling(event) {
        if (this.sliderAutoplayButton) {
            const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
            if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
            this.play()
        } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
            this.play()
        }
    }
    focusInHandling(event) {
        if (this.sliderAutoplayButton) {
            const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
            if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
                this.play()
            } else if (this.autoplayButtonIsSetToPlay) {
                this.pause()
            }
        } else if (this.announcementBarSlider.contains(event.target)) {
            this.pause()
        }
    }
    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed)
    }
    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay)
    }
    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow)
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow)
        }
    }
    autoRotateSlides() {
        const slideScrollPosition = this.currentPage === this.totalPages ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
        this.setSlidePosition(slideScrollPosition);
        this.applyAnimationToAnnouncementBar()
    }
    setSlideVisibility(event) {
        this.sliderItemsToShow.forEach((item, index) => {
            const linkElements = item.querySelectorAll('a');
            if (index === this.currentPage - 1) {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.removeAttribute('tabindex')
                    });
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex')
            } else {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.setAttribute('tabindex', '-1')
                    });
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1')
            }
        });
        this.wasClicked = !1
    }
    applyAnimationToAnnouncementBar(button = 'next') {
        if (!this.announcementBarSlider) return;
        const itemsCount = this.sliderItems.length;
        const increment = button === 'next' ? 1 : -1;
        const currentIndex = this.currentPage - 1;
        let nextIndex = (currentIndex + increment) % itemsCount;
        nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;
        const nextSlide = this.sliderItems[nextIndex];
        const currentSlide = this.sliderItems[currentIndex];
        const animationClassIn = 'announcement-bar-slider--fade-in';
        const animationClassOut = 'announcement-bar-slider--fade-out';
        const isFirstSlide = currentIndex === 0;
        const isLastSlide = currentIndex === itemsCount - 1;
        const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
        const direction = shouldMoveNext ? 'next' : 'previous';
        currentSlide.classList.add(`${animationClassOut}-${direction}`);
        nextSlide.classList.add(`${animationClassIn}-${direction}`);
        setTimeout(() => {
            currentSlide.classList.remove(`${animationClassOut}-${direction}`);
            nextSlide.classList.remove(`${animationClassIn}-${direction}`)
        }, this.announcerBarAnimationDelay * 2)
    }
    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition,
        })
    }
}
customElements.define('slideshow-component', SlideshowComponent);
class VariantSelects extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
        this.addEventListener('change', (event) => {
            const target = this.getInputForEventTarget(event.target);
            this.updateSelectionMetadata(event);
            publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
                data: {
                    event,
                    target,
                    selectedOptionValues: this.selectedOptionValues,
                },
            })
        })
    }
    updateSelectionMetadata({
        target
    }) {
        const {
            value,
            tagName
        } = target;
        if (tagName === 'SELECT' && target.selectedOptions.length) {
            Array.from(target.options).find((option) => option.getAttribute('selected')).removeAttribute('selected');
            target.selectedOptions[0].setAttribute('selected', 'selected');
            const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
            const selectedDropdownSwatchValue = target.closest('.product-form__input').querySelector('[data-selected-value] > .swatch');
            if (!selectedDropdownSwatchValue) return;
            if (swatchValue) {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                selectedDropdownSwatchValue.classList.remove('swatch--unavailable')
            } else {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                selectedDropdownSwatchValue.classList.add('swatch--unavailable')
            }
            selectedDropdownSwatchValue.style.setProperty('--swatch-focal-point', target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset')
        } else if (tagName === 'INPUT' && target.type === 'radio') {
            const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value
        }
    }
    getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target
    }
    get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(({
            dataset
        }) => dataset.optionValueId)
    }
}
customElements.define('variant-selects', VariantSelects);
class ProductRecommendations extends HTMLElement {
    observer = undefined;
    constructor() {
        super()
    }
    connectedCallback() {
        /* No product id means there is no product on this page to recommend
           against — the wishlist page is the case in the theme today. Rather
           than fetch with an empty product_id and get nothing back, the element
           waits: assets/fi-wishlist.js sets data-product-id and calls
           initializeRecommendations() itself once it knows what is saved. */
        if (!this.dataset.productId) return;
        this.initializeRecommendations(this.dataset.productId)
    }
    initializeRecommendations(productId) {
        this.observer?.unobserve(this);
        this.observer = new IntersectionObserver((entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);
            this.loadRecommendations(productId)
        }, {
            rootMargin: '0px 0px 400px 0px'
        });
        this.observer.observe(this)
    }
    loadRecommendations(productId) {
        fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`).then((response) => response.text()).then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations?.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML
            }
            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                this.remove()
            }
            if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded')
            }
        }).catch((e) => {
            console.error(e)
        })
    }
}
customElements.define('product-recommendations', ProductRecommendations);
class AccountIcon extends HTMLElement {
    constructor() {
        super();
        this.icon = this.querySelector('.icon')
    }
    connectedCallback() {
        document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this))
    }
    handleStorefrontSignInCompleted(event) {
        if (event?.detail?.avatar) {
            this.icon?.replaceWith(event.detail.avatar.cloneNode())
        }
    }
}
customElements.define('account-icon', AccountIcon);
class BulkAdd extends HTMLElement {
    constructor() {
        super();
        this.queue = [];
        this.requestStarted = !1;
        this.ids = []
    }
    startQueue(id, quantity) {
        this.queue.push({
            id,
            quantity
        });
        const interval = setInterval(() => {
            if (this.queue.length > 0) {
                if (!this.requestStarted) {
                    this.sendRequest(this.queue)
                }
            } else {
                clearInterval(interval)
            }
        }, 250)
    }
    sendRequest(queue) {
        this.requestStarted = !0;
        const items = {};
        queue.forEach((queueItem) => {
            items[parseInt(queueItem.id)] = queueItem.quantity
        });
        this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
        const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
        quickBulkElement.updateMultipleQty(items)
    }
    resetQuantityInput(id) {
        const input = this.querySelector(`#Quantity-${id}`);
        input.value = input.getAttribute('value');
        this.isEnterPressed = !1
    }
    setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select()
    }
    validateQuantity(event) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;
        if (inputValue < event.target.dataset.min) {
            this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min))
        } else if (inputValue > parseInt(event.target.max)) {
            this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max))
        } else if (inputValue % parseInt(event.target.step) != 0) {
            this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step))
        } else {
            event.target.setCustomValidity('');
            event.target.reportValidity();
            this.startQueue(index, inputValue)
        }
    }
    getSectionsUrl() {
        if (window.pageNumber) {
            return `${window.location.pathname}?page=${window.pageNumber}`
        } else {
            return `${window.location.pathname}`
        }
    }
    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
    }
}
if (!customElements.get('bulk-add')) {
    customElements.define('bulk-add', BulkAdd)
}

/* The original hover zoom — a translucent lens over the picture and a panel of
   the magnified crop beside the gallery. Kept for every product template except
   PDP v5, which uses the in-image lens further down. */
function initLegacyImageZoom() {
    /* v5 draws its own zoom; two of them on one gallery would fight over the
       same lens element. */
    if (document.querySelector('.fi-pdp-v5')) return;

    const activeMediaItems = document.querySelectorAll('.product__media-item');
    const lens = document.querySelector('.img-zoom-lens');
    const result = document.querySelector('.zoom-result');
    
    if (!activeMediaItems.length || !lens || !result) return;

    // Remove zoom from all images first
    activeMediaItems.forEach(item => {
        const img = item.querySelector('.product__media img');
        if (img) {
            img.removeEventListener('mousemove', moveLens);
            img.removeEventListener('mouseenter', showZoom);
            img.removeEventListener('mouseleave', hideZoom);
            item.removeEventListener('mouseleave', hideZoom);
        }
    });

    // Find the currently active media item
    const activeMediaItem = document.querySelector('.product__media-item.is-active');
    if (!activeMediaItem) return;
    
    const activeMedia = activeMediaItem.querySelector('.product__media img');
    if (!activeMedia) return;

    // Pre-setup the zoom result to prevent white flash
    function preSetupZoom() {
        if (window.innerWidth < 990) return;
        
        const zoomLevel = 2;
        result.style.backgroundImage = "url('" + activeMedia.src + "')";
        result.style.backgroundSize = (activeMedia.naturalWidth * zoomLevel) + "px " + (activeMedia.naturalHeight * zoomLevel) + "px";
        result.style.opacity = "0"; // Start invisible
    }

    function showZoom() {
        if (window.innerWidth < 990) return;
        
        if (activeMedia.complete && activeMedia.naturalWidth > 0) {
            setupZoom();
        } else {
            // If image isn't loaded yet, wait for it
            activeMedia.addEventListener('load', setupZoom);
            // Pre-setup anyway to load the background
            preSetupZoom();
        }
    }

    function setupZoom() {
        if (window.innerWidth < 990) return;
        
        const zoomLevel = 2;
        result.style.backgroundImage = "url('" + activeMedia.src + "')";
        result.style.backgroundSize = (activeMedia.naturalWidth * zoomLevel) + "px " + (activeMedia.naturalHeight * zoomLevel) + "px";
        
        // Show elements with smooth transition
        lens.style.display = "block";
        result.style.display = "block";
        
        // Fade in the result to prevent white flash
        setTimeout(() => {
            result.style.opacity = "1";
            result.style.transition = "opacity 0.1s ease";
        }, 10);
    }

    function hideZoom() {
        lens.style.display = "none";
        result.style.display = "none";
        result.style.opacity = "0"; // Reset opacity for next time
        result.style.transition = "none"; // Remove transition for instant hide
    }

    function moveLens(e) {
        if (window.innerWidth < 990) return;
        
        const rect = activeMedia.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        // Lens position (centered on cursor)
        let lensX = x - lens.offsetWidth / 2;
        let lensY = y - lens.offsetHeight / 2;
        
        // Keep lens within image bounds
        lensX = Math.max(0, Math.min(lensX, activeMedia.offsetWidth - lens.offsetWidth));
        lensY = Math.max(0, Math.min(lensY, activeMedia.offsetHeight - lens.offsetHeight));
        
        lens.style.left = (activeMedia.offsetLeft + lensX) + "px";
        lens.style.top = (activeMedia.offsetTop + lensY) + "px";
        
        // CORRECTED: Calculate background position for zoom
        const zoomLevel = 2;
        const bgWidth = activeMedia.naturalWidth * zoomLevel;
        const bgHeight = activeMedia.naturalHeight * zoomLevel;
        
        // Calculate what percentage of the image the lens is viewing
        const percentX = lensX / (activeMedia.offsetWidth - lens.offsetWidth) || 0;
        const percentY = lensY / (activeMedia.offsetHeight - lens.offsetHeight) || 0;
        
        // Calculate background position to show the correct portion
        const bgX = percentX * (bgWidth - result.offsetWidth);
        const bgY = percentY * (bgHeight - result.offsetHeight);
        
        result.style.backgroundPosition = `-${bgX}px -${bgY}px`;
    }

    /* Add event listeners to the currently active image */
    activeMedia.addEventListener("mousemove", moveLens);
    activeMedia.addEventListener("mouseenter", showZoom);
    activeMedia.addEventListener("mouseleave", hideZoom);
    activeMediaItem.addEventListener("mouseleave", hideZoom);

    // Pre-setup zoom for the active image on initialization
    if (activeMedia.complete) {
        preSetupZoom();
    } else {
        activeMedia.addEventListener('load', preSetupZoom);
    }
}

/* Product image zoom: a square lens that magnifies in place.

   The magnified crop is painted inside the lens itself, so the zoom never
   leaves the product image (the previous build pushed a 400px panel out into
   the product info column). Desktop only. Listeners are delegated off
   <media-gallery>, so a slide change, thumbnail click or variant media swap
   needs no re-binding. */
const ZOOM_LENS_RATIO = 2.25;
const ZOOM_LENS_SIZE = 240;
const ZOOM_LENS_MIN_WIDTH = 990;

/* The gallery <img> src is already the 1946px render, but a variant swap can
   leave a narrower srcset pick in currentSrc — ask the CDN for the big one so
   the crop stays sharp at 2.25x. */
function zoomLensSource(image) {
    const source = image.currentSrc || image.src;
    try {
        const url = new URL(source, window.location.href);
        if (url.searchParams.has('width')) {
            url.searchParams.set('width', '1946');
            return url.href;
        }
    } catch (error) {
        /* Not a parseable URL — use it as it came. */
    }
    return source;
}

/* Where the picture actually sits inside the <img> box once object-fit has had
   its say: `cover` crops a ratio mismatch, `contain` letterboxes it. Assumes
   object-position: center center, which base.css sets. */
function zoomRenderedBox(image, rect) {
    const { naturalWidth, naturalHeight } = image;
    const box = { left: 0, top: 0, width: rect.width, height: rect.height };
    if (!naturalWidth || !naturalHeight) return box;

    const fit = getComputedStyle(image).objectFit;
    let scale;
    if (fit === 'contain' || fit === 'scale-down') {
        scale = Math.min(rect.width / naturalWidth, rect.height / naturalHeight);
    } else if (fit === 'cover') {
        scale = Math.max(rect.width / naturalWidth, rect.height / naturalHeight);
    } else {
        return box;
    }

    const width = naturalWidth * scale;
    const height = naturalHeight * scale;
    return {
        left: (rect.width - width) / 2,
        top: (rect.height - height) / 2,
        width,
        height
    };
}

function moveZoomLens(lens, image, event) {
    const parent = lens.offsetParent || lens.parentElement;
    if (!parent) return;

    const imageRect = image.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    if (!imageRect.width || !imageRect.height) return;

    /* Never let the lens grow past the picture it is sitting on. */
    const size = Math.round(Math.min(ZOOM_LENS_SIZE, imageRect.width * 0.6, imageRect.height * 0.6));
    lens.style.width = `${size}px`;
    lens.style.height = `${size}px`;

    /* Lens box: centred on the cursor, clamped inside the image. */
    const x = event.clientX - imageRect.left;
    const y = event.clientY - imageRect.top;
    const lensX = Math.max(0, Math.min(x - size / 2, imageRect.width - size));
    const lensY = Math.max(0, Math.min(y - size / 2, imageRect.height - size));

    lens.style.left = `${imageRect.left - parentRect.left - parent.clientLeft + lensX}px`;
    lens.style.top = `${imageRect.top - parentRect.top - parent.clientTop + lensY}px`;

    /* The crop, at ZOOM_LENS_RATIO times the displayed size.

       The lens is pinned inside the picture, so a crop centred on the lens centre
       could never reach the outer edges: at the far left the lens centre is
       already half a lens in, which left roughly a 67px band down every side —
       and both bands at once in the corners — that the zoom would not show.
       Mapping the lens's travel onto the crop's travel instead reaches the very
       corners at the extremes, keeps the middle centred where it was, and never
       leaves blank space beside the crop. */
    const rendered = zoomRenderedBox(image, imageRect);
    const zoomWidth = rendered.width * ZOOM_LENS_RATIO;
    const zoomHeight = rendered.height * ZOOM_LENS_RATIO;
    const travelX = imageRect.width - size;
    const travelY = imageRect.height - size;
    const backgroundX = travelX > 0 ? (lensX / travelX) * Math.max(0, zoomWidth - size) : 0;
    const backgroundY = travelY > 0 ? (lensY / travelY) * Math.max(0, zoomHeight - size) : 0;

    lens.style.backgroundSize = `${zoomWidth}px ${zoomHeight}px`;
    lens.style.backgroundPosition = `-${backgroundX}px -${backgroundY}px`;
    lens.style.display = 'block';
}

function setupGalleryZoom(gallery) {
    if (gallery.dataset.zoomLens === 'ready') return;
    gallery.dataset.zoomLens = 'ready';

    /* Its own element rather than the .img-zoom-lens the gallery ships with. That
       one belongs to the legacy zoom and carries rules this cannot live with —
       a translucent wash, and from the section's #zoomLens-… id rule an
       !important background, which beats an inline style and would wipe out the
       crop painted here. Styling lives in fi-pdp-v5.css. */
    const lens = document.createElement('div');
    lens.className = 'fi-zoom-lens';
    lens.setAttribute('aria-hidden', 'true');
    gallery.appendChild(lens);

    let activeImage = null;
    let activeSource = null;
    let loadedSource = null;
    let lastMove = null;

    /* Where the lens rests between hovers. It only moves in beside a picture
       while that picture is being hovered — parked inside a slide it would be
       swept away with it when a variant swap replaces the gallery items. */
    const lensHome = lens.parentElement;

    const hideLens = () => {
        lens.style.display = 'none';
        if (lensHome && lens.parentElement !== lensHome) lensHome.appendChild(lens);
        activeImage = null;
        activeSource = null;
        lastMove = null;
    };

    /* Resolve from the slide, not the event target: an image can sit under the
       transparent lightbox toggle button. Video and 3D slides have no
       .product__media img, so they get no lens. */
    const imageUnderCursor = (event) => {
        const item = event.target.closest('.product__media-item');
        return item ? item.querySelector('.product__media img') : null;
    };

    /* Parked outside the picture the lens painted *under* it however high its
       z-index went — a different subtree, and product shots are transparent PNGs,
       so it showed up as the sofa sitting on top of the zoom. Moving it in beside
       the <img> settles the stacking outright: same box, later in the DOM, both
       positioned. */
    const attachTo = (image) => {
        const media = image.parentElement;
        if (media && lens.parentElement !== media) media.appendChild(lens);
    };

    /* Hold the lens back until the full-size crop has decoded — otherwise the
       first hover flashes an empty white square. */
    const loadCrop = (image) => {
        const source = zoomLensSource(image);
        if (source === loadedSource) return;

        loadedSource = null;
        lens.style.display = 'none';

        const crop = new Image();
        crop.onload = () => {
            if (activeImage !== image) return;
            loadedSource = source;
            lens.style.backgroundImage = `url('${source}')`;
            /* The cursor may have come to rest while the crop loaded, so draw
               from the last known position instead of waiting for a move. */
            if (lastMove) {
                attachTo(image);
                moveZoomLens(lens, image, lastMove);
            }
        };
        crop.src = source;
    };

    gallery.addEventListener('mousemove', (event) => {
        if (window.innerWidth < ZOOM_LENS_MIN_WIDTH) return hideLens();

        const image = imageUnderCursor(event);
        if (!image || !image.complete || !image.naturalWidth) return hideLens();

        lastMove = { clientX: event.clientX, clientY: event.clientY };

        /* Compare the src too: a variant swap reuses the same <img> element. */
        const source = image.currentSrc || image.src;
        if (image !== activeImage || source !== activeSource) {
            activeImage = image;
            activeSource = source;
            loadCrop(image);
        }

        if (!loadedSource) return;
        attachTo(image);
        moveZoomLens(lens, image, event);
    });

    gallery.addEventListener('mouseleave', hideLens);
    window.addEventListener('resize', hideLens);
    window.addEventListener('scroll', hideLens, { passive: true });
}

/* Which zoom a page gets is decided by the layout: the in-image lens on PDP v5,
   the original lens-and-panel everywhere else. .fi-pdp-v5 lands on
   <product-info> whenever the section carries fi_* blocks — see the detection at
   the top of sections/main-product.liquid.

   The stacked templates carry it too (see sections/stacked-main-product.liquid),
   so the in-image lens is what their gallery gets as well. Those layouts keep
   their own gallery *grid* — that is what .fi-pdp-v5--own-gallery-layout holds
   back in fi-pdp-v5.css — but the zoom is shared. The lens only needs a
   <media-gallery> with .product__media-item > .product__media img slides, and
   both galleries build their slides from snippets/product-thumbnail.liquid.

   Kept as one entry point named initImageZoom because assets/back-button-fix.js
   calls it by name after a history restore. */
function initImageZoom() {
    document.querySelectorAll('.fi-pdp-v5 media-gallery').forEach(setupGalleryZoom);
    initLegacyImageZoom();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageZoom);
} else {
    initImageZoom();
}

/* A section re-rendered by the theme editor brings a fresh, unbound lens. */
document.addEventListener('shopify:section:load', initImageZoom);

/* ---- the legacy zoom's own re-binding hooks ----
   It captures the active slide's <img> when it runs, so it has to run again
   whenever that changes. The v5 path delegates off the gallery and ignores these
   (setupGalleryZoom is guarded by data-zoom-lens). */
document.addEventListener('slideChanged', function () {
    setTimeout(initImageZoom, 100);
});

document.addEventListener('click', function (event) {
    if (event.target.closest('.thumbnail') || event.target.closest('.thumbnail-list__item')) {
        setTimeout(initImageZoom, 150);
    }
});

window.addEventListener('resize', function () {
    setTimeout(initImageZoom, 300);
});
